export enum DealViewSource {
  Dashboard = 1,
  GamesPage = 2,
}
